import { safeCallAsync } from '@xemplo/safe-call';

/**
 * Executes a mutation with safeCallAsync and calls onSuccess if it resolves
 * without error. Centralises the safeCallAsync + error-guard pattern used
 * across mutation hooks.
 */
export async function runMutation(
  mutationFn: () => Promise<unknown>,
  onSuccess: () => void,
): Promise<void> {
  const [, error] = await safeCallAsync(mutationFn());
  if (error) return;
  onSuccess();
}
